import {Injectable, OnDestroy} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {
  MumaEntity,
  UitstelEntity,
  UitstelGegevens,
  UitstelGegevensBelastingmiddel,
} from "@snelstart-ventures/fiscaal/domain-logic";

@Injectable({providedIn: 'root'})
export class BokkzUitstelDataService implements OnDestroy {

  public uitstelEntityList = new BehaviorSubject<UitstelEntity[]>(this.getFromSessionStorage<UitstelEntity[]>('updateUitstelList') || <UitstelEntity[]>{});
  public uitstelGegevensList = new BehaviorSubject<UitstelGegevens[]>(this.getFromSessionStorage<UitstelGegevens[]>('uitstelGegevensList') || <UitstelGegevens[]>{});
  public uitstelGegevens = new BehaviorSubject<UitstelGegevens>(this.getFromSessionStorage<UitstelGegevens>('uitstelGegevens') || <UitstelGegevens>{});
  public isIb = new BehaviorSubject<boolean>(false);
  public isAangevraagd = new BehaviorSubject<boolean>(false);
  public isToegekend = new BehaviorSubject<boolean>(false);

  constructor() {
    this.applyDebounceTime();
  }

  private applyDebounceTime() {
    const debounceDelay = 500; // Timeout voor toetsaanslagen
  }

  private getFromSessionStorage<T>(key: string): T | null {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  }

  private saveToSessionStorage(key: string, value: any) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  updateUitstelList(uistelLijst: MumaEntity[]) {
    this.uitstelEntityList.next(uistelLijst)
  }

  updateGegevensList(uitstelGegevensLijst: UitstelGegevens[]) {
    this.uitstelGegevensList.next(uitstelGegevensLijst)
  }

  updateGegevens(uitstelGegevens: UitstelGegevens) {
    this.isIb.next(uitstelGegevens.belastingmiddel.includes(UitstelGegevensBelastingmiddel.INKOMSTENBELASTING.toString()))
    this.isAangevraagd.next(uitstelGegevens.datumAanvraag !== undefined)
    this.isToegekend.next(uitstelGegevens.datumUitstelTot !== undefined)
    this.uitstelGegevens.next(uitstelGegevens)
  }

  ngOnDestroy(): void {
    if (this.uitstelEntityList) {
      this.uitstelEntityList?.unsubscribe()
    }
    if (this.uitstelGegevensList) {
      this.uitstelGegevensList?.unsubscribe()
    }
    if (this.uitstelGegevens) {
      this.uitstelGegevens?.unsubscribe()
    }
    if (this.isIb) {
      this.isIb?.unsubscribe()
    }
    if (this.isAangevraagd) {
      this.isAangevraagd?.unsubscribe()
    }
    if (this.isToegekend) {
      this.isToegekend?.unsubscribe()
    }
  }
}
